import { QueryFunctionContext, QueryKey, useInfiniteQuery, UseInfiniteQueryOptions } from "@tanstack/react-query";
import { OrderHistory, ORDERS_HISTORY_PARAMS } from "@core/types";
import { ordersClient } from "@core/clients";
import { ORDERS_QUERY_CACHE_EXPIRE_TIME_MS } from "../../config/constansts";

type Options = UseInfiniteQueryOptions<OrderHistory[], any>;

const useInfiniteGetOrdersHistoryQuery = (config: { options?: Options; params?: ORDERS_HISTORY_PARAMS } = {}) => {
  return useInfiniteQuery<OrderHistory[], any>(
    ["orders", config.params!],

    async (queryContext: QueryFunctionContext<QueryKey, ORDERS_HISTORY_PARAMS>) => {
      const { pageParam = { page: config.params?.page } } = queryContext;

      return await ordersClient.getOrdersHistory({
        page: pageParam.page!,
        per_page: config.params?.per_page ? config.params.per_page : 10,
      });
    },

    {
      getNextPageParam: (lastRes, allOrders) => {
        const perPage = config.params?.per_page ? config.params.per_page : 10;
        const itemsAmount = allOrders.reduce((a: number, b: any[]) => a + b.length, 0);

        if (lastRes.length === perPage) {
          return {
            page: Math.ceil(itemsAmount / perPage) + 1,
          };
        }

        return undefined;
      },

      cacheTime: ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      staleTime: ORDERS_QUERY_CACHE_EXPIRE_TIME_MS,
      ...config.options,
    }
  );
};

export default useInfiniteGetOrdersHistoryQuery;
